import { render, staticRenderFns } from "./ViewSentQuotes.vue?vue&type=template&id=7c2a0f6b&scoped=true"
import script from "./ViewSentQuotes.vue?vue&type=script&lang=js"
export * from "./ViewSentQuotes.vue?vue&type=script&lang=js"
import style0 from "./ViewSentQuotes.vue?vue&type=style&index=0&id=7c2a0f6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2a0f6b",
  null
  
)

export default component.exports